import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const VerifyEmailPage = () => {
        const [searchParams] = useSearchParams();
        const [status, setStatus] = useState('loading'); // loading | success | error
        const [errorMessage, setErrorMessage] = useState('');
        const navigate = useNavigate();
        const called = useRef(false);

        useEffect(() => {
                if (called.current) return;
                called.current = true;

                const token = searchParams.get('token');
                if (!token) {
                        setErrorMessage('Invalid or missing verification link.');
                        setStatus('error');
                        return;
                }

                fetch(`/api/v2/register/verify?token=${token}`)
                        .then((res) => {
                                if (res.ok) {
                                        setStatus('success');
                                } else {
                                        return res.json().then((data) => {
                                                setErrorMessage(data?.message || 'Verification failed. The link may have expired.');
                                                setStatus('error');
                                        });
                                }
                        })
                        .catch(() => {
                                setErrorMessage('Something went wrong. Please try again.');
                                setStatus('error');
                        });
        }, [searchParams]);

        return (
                <div className="flex items-center justify-center h-screen bg-bg-page">
                        <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md text-center">
                                <img src="/images/logo_text_color.png" alt="CleverPlant" className="h-10 mx-auto mb-2" />

                                {status === 'loading' && (
                                        <>
                                                <div className="text-brand text-4xl mb-4 animate-spin">⟳</div>
                                                <p data-testid="verify-pending" className="text-gray-600">Verifying your email…</p>
                                        </>
                                )}

                                {status === 'success' && (
                                        <>
                                                <div className="text-green-600 text-5xl mb-4">✓</div>
                                                <h1 data-testid="verify-success" className="text-2xl font-bold text-gray-900">Email Verified!</h1>
                                                <p className="text-gray-600">Your account is now active. You can sign in.</p>
                                                <button
                                                        onClick={() => navigate('/login')}
                                                        className="flex justify-center w-full px-4 py-2 text-sm font-medium text-white bg-brand border border-transparent rounded-md shadow-sm hover:bg-brand/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand"
                                                >
                                                        Go to Sign In
                                                </button>
                                        </>
                                )}

                                {status === 'error' && (
                                        <>
                                                <div className="text-red-500 text-5xl mb-4">✕</div>
                                                <h1 data-testid="verify-failed" className="text-2xl font-bold text-gray-900">Verification Failed</h1>
                                                <p className="text-gray-600">{errorMessage}</p>
                                                <button
                                                        onClick={() => navigate('/login')}
                                                        className="flex justify-center w-full px-4 py-2 text-sm font-medium text-white bg-brand border border-transparent rounded-md shadow-sm hover:bg-brand/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand"
                                                >
                                                        Go to Sign In
                                                </button>
                                        </>
                                )}
                        </div>
                </div>
        );
};

export default VerifyEmailPage;
